// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hover":"_26_jT","underline":"_3d7TN","horizontal-padding--mobile":"_2XDRZ"};